import React, { useState, useEffect, useContext } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import MaterialTypography from "../../components/MaterialTypography";
import {
  AppBar,
  Autocomplete,
  Badge,
  Card,
  CardHeader,
  Grid2,
  Stack,
  styled,
  Tab,
  Tabs,
  TextField,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import MaterialButton from "../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import BASEURL from "../Utils/Baseurl";
import axios from "axios";
import MaterialBox from "../../components/MaterialBox";
import breakpoints from "../../assest/theme/base/breakpoints";
import UserDetailsContext from "../../context/auth";
import { fetchAll } from "../../ApiBaseUrl";
import MaterialInput from "../../components/MaterialInput";

//CSS for material UI Badge
const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    right: -1,
    top: -6,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: "0 4px",
  },
}));

const EmployeeManagement = () => {
  //pages
  const [totalCount, setTotalCount] = useState(0);

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [categoriesOptions, setcategoriesOptions] = useState([
    { value: "Category 1", label: "Category 1" },
    { value: "Category 2", label: "Category 2" },
    { value: "Category 3", label: "Category 3" },
    { value: "Category 4", label: "Category 4" },
  ]);

  const [branchOptions, setbranchOptions] = useState([]);

  const [categories, setcategories] = useState([]);

  const [emplyoee, setEmployee] = useState("");

  const [branches, setbranches] = useState([]);

  const navigate = useNavigate();
  const { user, AccessData, setEmpSubmit } = useContext(UserDetailsContext);

  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });
  const [userDetails, setUserDetails] = useState({
    department: "",
    designation: "",
    employeeType: "",
  });
  const [roledata, setroledata] = useState([]);
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [tabValue, setTabValue] = useState(0);
  const [employeeList, setEmployeeList] = useState([]);

  useEffect(() => {
    onEmployeeeSubmit();
    getroles();
  }, [paginationModel]);

  useEffect(() => {
    onEmployeeeSubmit();
  }, [branches, categories, paginationModel,emplyoee]);

  useEffect(() => {
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }

    window.addEventListener("resize", handleTabsOrientation);

    handleTabsOrientation();

    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, [tabsOrientation]);

  useEffect(() => {
    const fetchBranches = async () => {
      // setCirleLoading(true);
      try {
        const fields = [
          "id",
          "name",
          "description",
          "address",
          "state",
          "zipCode",
          "branchIncharge",
        ];
        const data = await fetchAll("Branch", fields);
        let result = data?.allBranch;
        let filterdata = result.map((val) => {
          return {
            value: val.id,
            label: val.name,
          };
        });
        setbranchOptions(filterdata);
      } catch (error) {
        console.error("Error fetching branches:", error);
      } finally {
        // setCirleLoading(false);
      }
    };

    fetchBranches();
  }, []);

  const employeeListTable = {
    columns: [
      {
        field: "empid",
        headerName: "Employee Id",
        width: 150,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "firstName",
        headerName: "User Name",
        width: 150,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "contactNumber",
        headerName: "Contact Number",
        width: 150,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "role",
        headerName: "Role",
        width: 150,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },

      {
        field: "employeeType",
        headerName: "Employee Type",
        width: 150,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "employeeCategory",
        headerName: "Employee Category",
        width: 150,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
    ],

    rows: employeeList.map((performance) => {
      const role = roledata?.find((r) => r.id == performance?.role?.id);
      return {
        id: performance.id,
        empid: performance.empid,
        firstName: performance.firstName + " " + performance?.lastName,

        contactNumber: performance.contactNumber,

        role: role?.role,
        employeeType: performance?.employeeType,
        employeeCategory: performance?.category,
      };
    }),
  };

  const handleNewEmployee = () => {
    setEmpSubmit(false);

    navigate("/employee-management/add-employee");
  };

  const handlefilter = (event, name) => {
    let state = name == "categories" ? { ...categories } : { ...branches };

    const selecteddata = event;

    // categoriesState["categoriesDaysStatus"] =
    // selectedDays.length > 0 ? "success" : "unchecked";

    state = selecteddata.map((day) => day.label);
    if (name == "categories") {
      setcategories(state);
    } else {
      setbranches(state);
    }
  };

  const onEmployeeListClick = (e) => {
    setEmpSubmit(true);
    if (e?.id) {
      navigate(`/employee-management/add-employee?id=${e?.id}`);
    }
  };
  const getroles = async () => {
    const query = `query{
   allRoles{
     data{
       id
       role
       description
     }
   }
 }`;
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      const wfhList = response.data.data.allRoles[0]?.data;
      setroledata(wfhList);
    } catch (error) {
      console.log("Error:", error);
    }
  };

  const onEmployeeeSubmit = async () => {
    const query = `
      query allUsersDetailWithPagination(
  $categories: [String]
  $branches: [String]
  $page: Int
  $pageSize: Int
  $search: String
) {
  allUsersDetailWithPagination(
    categories: $categories
    branches: $branches
    page: $page
    pageSize: $pageSize
    search: $search
  ) {
    success
    message
 
    data {
        id
        firstName
        lastName
        fathersName
        dateOfBirth
        email
        gender
        username
        empid
        contactNumber
        secondaryContactNumber
        aadharNumber
        panNumber
        employeeType
        category
        branch
        maritalStatus
        address
        country
        state
        city
        zipCode
        dateOfJoining
        LastWorkingDay
        otApplicable
        shift
        esicNumber
        uanNumber
        memberId
        isUser
        isActive
      isSuperuser
        role {
          id
        }
        bankDetails {
          accountNumber
          bankName
          ifscNumber
          branchName
          cifNumber
        }
        salaryDetails {
          basicAmount
          daAmount
          mealsAmountPerDay
          otAmountPerHour
          shiftPaisa
          attendanceAmount
          busFare
        }
        aadharAttachment 
        nomineeAadharAttachment 
        panAttachment 
        bankPassbookAttachment 
        nomineeName 
        nomineeRelationship 
    }
 
    pagination {
      totalCount
      currentPage
      totalPages
      hasNextPage
      hasPreviousPage
    }
  }
}
   `;

    try {
      setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: {
            categories: categories,
            branches: branches,
            page: paginationModel?.page + 1,
            search:emplyoee
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      // Ensure response structure is correct
      if (
        response.data &&
        response.data.data &&
        response.data.data.allUsersDetailWithPagination
      ) {
        const empList = response.data.data.allUsersDetailWithPagination?.data;
        const totalcount =
          response.data.data.allUsersDetailWithPagination?.pagination
            ?.totalCount;

        setTotalCount(Number(totalcount));

        // Filter out employees where empid is empty/null
        const filteredData = empList.filter((val) => !val.isSuperuser);

        console.log("Filtered Employee Data", filteredData);

        // Update state
        setEmployeeList(filteredData);
        setPageState({ ...pageState, loading: false, state: "success" });
      } else {
        throw new Error("Invalid response structure from API");
      }
    } catch (error) {
      console.error("Error fetching employee list:", error);
      setPageState({
        ...pageState,
        loading: false,
        error: true,
        message: error.message,
      });
    }
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Employee Management List
                </MaterialTypography>
              </Stack>

              {AccessData &&
                Array.isArray(AccessData) &&
                AccessData.some(
                  (item) => item.component === "AddEmployee" && item.can_access,
                ) && (
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={() => handleNewEmployee()}
                  >
                    Employee
                  </MaterialButton>
                )}
            </Stack>
          }
        />
        <Grid2 size={{ xs: 12, md: 12, lg: 12 }} container spacing={1} p={1}>
          <Grid2 size={{ xs: 12, md: 12, lg: 4 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Categories
              </MaterialTypography>
            </MaterialBox>
            <Autocomplete
              multiple
              options={categoriesOptions.filter(
                (option) => !categories?.includes(option.value), // 👈 custom filter
              )}
              value={categories.map((day) => ({
                value: day,
                label: day,
              }))}
              onChange={(event, newValue) =>
                handlefilter(newValue, "categories")
              }
              getOptionLabel={(option) => option.label}
              // disabled={togglePage.view === true}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Choose multiple Categories"
                />
              )}
            />
          </Grid2>

          <Grid2 size={{ xs: 12, md: 12, lg: 4 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Branches
              </MaterialTypography>
            </MaterialBox>
            <Autocomplete
              multiple
              options={branchOptions.filter(
                (option) => !branches.includes(option.label), // 👈 custom filter
              )}
              value={branches.map((day) => ({
                value: day,
                label: day,
              }))}
              onChange={(event, newValue) => handlefilter(newValue, "branches")}
              getOptionLabel={(option) => option.label}
              // disabled={togglePage.view === true}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Choose multiple Branches"
                />
              )}
            />
          </Grid2>
          <Grid2 size={{ xs: 12, md: 12, lg: 4 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Search
              </MaterialTypography>
            </MaterialBox>
            <MaterialInput
              name="startDate"
              type="text"
              placeholder="Enter Emplyoee Search"
              onChange={(e) => setEmployee(e.target.value)}
            />
          </Grid2>
        </Grid2>

        <MaterialDataGrid
          customHeight={550}
          paginationModel={paginationModel}
          setPaginationModel={setPaginationModel}
          rowCount={totalCount}
          rows={employeeListTable.rows}
          columns={employeeListTable.columns}
          checkboxSelection={false}
          isSelectable={true}
          onRowClick={onEmployeeListClick}
          loading={pageState.loading}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No employee found
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  You have not yet added any employee details. Click on the "Add
                  Employee" button to start adding employee details.
                </MaterialTypography>
              </Stack>
            ),
          }}
        />
      </Card>
    </DashboardLayout>
  );
};

export default EmployeeManagement;
